import React from 'react';

import { ColumnShimmer } from '../../ColumnShimmer';

export const TaxImpactEstimateLoading: React.FC = () => {
  return <ColumnShimmer columns={2} data-testid="tax-impact-estimate-shimmer" />;
};
